import { createHashCode } from "@/helpers/utils";
import { store } from "@/store";

let connection;
export const connectSocket = (userUid, userToken) => {
  let loginRequest = {
    msg: "method",
    method: "login",
    id: createHashCode(),
    params: [{ resume: userToken }]
  };
  let connect = {
    msg: "connect",
    version: "1",
    support: ["1"]
  };
  let notifyUser = {
    msg: "sub",
    id: createHashCode(),
    name: "stream-notify-user",
    params: [userUid + "/notification", false]
  };
  let notifyUserRoom = {
    msg: "sub",
    id: createHashCode(),
    name: "stream-notify-user",
    params: [userUid + "/rooms-changed", false]
  };
  if (connection) connection.close();
  connection = new WebSocket(process.env.VUE_APP_WEBSOCKET_URL);
  connection.onmessage = function(e) {
    let response = JSON.parse(e.data);
    if (response.msg !== "ping") {
      console.log(response);
      if (response.msg === "changed") {
        store.commit("chat/setSocketEvent", response);
      }
    } else {
      connection.send(JSON.stringify({ msg: "pong" }));
    }
  };
  connection.onopen = () => {
    connection.send(JSON.stringify(connect));
    connection.send(JSON.stringify(loginRequest));
    connection.send(JSON.stringify(notifyUser));
    connection.send(JSON.stringify(notifyUserRoom));
  };
};
export const cancelLogInIframeAuth = () => {
  localStorage.removeItem("isLoggedInIframe");
  localStorage.removeItem("isModeSupporter");
};
export const isMessageFromGeneralGroup = message => {
  return message === "GENERAL";
};
